import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AvatarModule } from '../avatar/avatar.module';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';

import { AssessmentPreviewDialog } from './assessment-preview-dialog.component';
import { VarModule } from '../../directives/ngVar';
import { DateSelectDialog } from '../date-select-dialog/date-select-dialog.component';

@NgModule({
  declarations: [
    AssessmentPreviewDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    AvatarModule,
    MatDialogModule,
    MatButtonModule,
    VarModule
  ],
  exports: [
    AssessmentPreviewDialog
  ],
  providers: [
    DateSelectDialog
  ]
})
export class AssessmentPreviewDialogModule { }
